import React from 'react';

const TransactionsHead: React.FC = React.memo(() => {
  return <div style={{ textAlign: 'right' }}>Transactions</div>;
});

export default TransactionsHead;
